import { InjectionToken } from '@angular/core';

export type PhotoAnnotationFlattener = (imageSrc: string, annotations: unknown[] | undefined) => Promise<string>;

export const PHOTO_ANNOTATION_FLATTENER = new InjectionToken<PhotoAnnotationFlattener>('PHOTO_ANNOTATION_FLATTENER');
